/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Mem_OkInputs */

const en_mk_tut_mem_ok = /** @type {(inputs: Mk_Tut_Mem_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redo the work that came out wrong; the agent’s output now follows the new rule.`)
};

const id_mk_tut_mem_ok = /** @type {(inputs: Mk_Tut_Mem_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulangi pekerjaan yang tadi salah; hasil agen sekarang mengikuti aturan baru itu.`)
};

/**
* | output |
* | --- |
* | "Redo the work that came out wrong; the agent’s output now follows the new rule." |
*
* @param {Mk_Tut_Mem_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_mem_ok = /** @type {((inputs?: Mk_Tut_Mem_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Mem_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_mem_ok(inputs)
	return en_mk_tut_mem_ok(inputs)
});